export default "__VITE_ASSET__upAmpQU8__"